import React from 'react';
import logo from './logo.svg';
import './App.css';

import IndexPage from './IndexPage';
import GlitchLanguage from './GlitchLanguage';
import PageNotFound from './PageNotFound';
import WebDemo from './WebDemo';

function App() {
  const { pathname } = window.document.location;

  const page = {
    '/': <WebDemo />,
    '/glitch-language': <GlitchLanguage />,
    '/web-demo': <WebDemo />,
  };

  return (
    <div className="App">
      {typeof page[pathname] !== 'undefined'
        ? page[pathname]
        : PageNotFound
      }
    </div>
  );
}

export default App;
